import { useState } from 'react'

import { Button, Modal, Select } from 'antd'
import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { isObject } from '../../../utils'
import { recoverBadgeAssignation } from '../../../utils/api/badge'
import { selectUser } from '../../../reducers/UserReducer'
import { getters, TERMINATED } from '../../../utils/entities/badge'
import moment from 'moment'
import { FULL_DATE_FORMAT } from '../../../utils/momentjs'

const RECOVERY_STATUSES = [
  { key: 1, text: 'Lost' },
  { key: 2, text: 'Defect' },
  { key: 3, text: 'Stolen' },
  { key: 4, text: 'Recovered by institution' },
  { key: 0, text: 'Other' }
]

const BadgeRecoveryModal = ({ badgeAssignation, onClose, onRecover }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [recoveryValue, setRecoveryValue] = useState(null)

  const handleClose = () => {
    setRecoveryValue(null)
    onClose()
  }

  const handleBadgeRecovery = () => {
    const newData = { ...badgeAssignation }

    newData.endDate = moment().format(FULL_DATE_FORMAT)
    newData.status = TERMINATED
    newData.recoveryReason = recoveryValue

    recoverBadgeAssignation(user, user.institutions[0], { id: getters.badgeAssignationId(newData) }, newData).then(({ data }) => {
      onRecover(data)
    })

    handleClose()
  }

  return (
    <Modal
      visible={isObject(badgeAssignation)}
      title={t('Why do you want to recover this badge?')}
      onCancel={handleClose}
      footer={
        <div>
          <Button type='secondary' onClick={handleClose}> {t('Cancel')} </Button>
          <Button type='primary' onClick={handleBadgeRecovery}> {t('OK')} </Button>
        </div>
      }
    >
      <Select style={{ width: '100%' }} onChange={setRecoveryValue}>
        {RECOVERY_STATUSES.map(s => {
          return (
            <Select.Option key={s.key} value={s.key}>{t(s.text)}</Select.Option>
          )
        })}
      </Select>
    </Modal>
  )
}

export default BadgeRecoveryModal
